const hd = $(".header"), mTg = $('#menuToggle')

window.viewport = () => {
    var e = window,
        a = 'inner';
    if (!('innerWidth' in window)) {
        a = 'client';
        e = document.documentElement || document.body
    }
    return {
        width: e[a + 'Width'],
        height: e[a + 'Height']
    }
}

window.updateMenu = (elem) => {
    if (window.viewport().width >= 1230) {
        $('.menuMob').removeClass('mobile')
        hd.removeClass('mobile')

        $('.nav').appendTo('#navDesk')
        $('.headerAccess').appendTo('#accessDesk')
        $('.searchbox').appendTo('.searchboxWrap')
        $('.buttonLang').insertAfter('#accessDesk')
        
        return document.querySelector('.footerBottom')
    } else {
        $('.menuMob').addClass('mobile')
        hd.addClass('mobile')
        
        $('.nav').appendTo('#navMob')
        $('.headerAccess').appendTo('#accessMob')
        $('.searchbox').insertBefore('#accessMob')
        $('.buttonLang').insertBefore('.searchbox')

        return document.querySelector('footer')
    }
}

window.uncheckedMenu = () => {
    mTg.prop('checked', false)
}

window.hideMenuMobile = () => {
    $('.menuMob').removeClass('active')
    $('.menu').removeClass('active')
}

window.changeLanguage = (el) => {
    lang = el.getAttribute('value')
    if (lang == "id") {
        el.setAttribute('value', 'eng')
    } else {
        el.setAttribute('value', 'id')
    }
}

window.triggerActiveButton = function(el, txt, txtrev) {
    elActive = el.classList.contains('active')
    el.classList.toggle('active')
    if (!!txt) {
        if (elActive == false) {
            el.innerHTML = txt
        } else {
            el.innerHTML = txtrev
        }
    }
}

let isVideoSliderInitialized = false;
window.triggerPopup = (el) => {
    let target = document.querySelector(el)
    target.classList.add('active');

    if (target.classList.contains('-popDetailVideo')) {
        
        let video = target.querySelector('video');
        if (video) {
            video.play();
        }
    }
}

window.closePopup = (el) => {
    let pop = document.querySelectorAll(".popup")
    const videos = document.querySelectorAll(".popup video");
    videos.forEach(video => {
        video.pause();
        video.currentTime = 0;
    });
    if (!!el) {
        let dpop = document.querySelector(el)
        dpop.classList.remove('active');
    } else {
        pop.forEach(popup => {
            popup.classList.remove('active');
        });
    }
}

window.togglePassword = (el) => {
    const input = el.getAttribute("toggle"),
        pass = document.querySelector(input),
        type = pass.getAttribute("type")
    
    if (type == "password") {
        pass.setAttribute("type", "text")
        el.classList.add("show")
    } else {
        el.classList.remove("show")
        pass.setAttribute("type", "password")
    }
}

window.ImgUpload = () => {
    var imgWrap = "";
    var imgArray = [];

    $('.uploadInput').each(function () {
        $(this).on('change', function (e) {
            imgWrap = $(this).closest('.upload').find('.-uploadedImage');
            var maxLength = $(this).attr('data-max_length');
            var multiple = $(this).attr('multiple');

            var files = e.target.files;
            var filesArr = Array.prototype.slice.call(files);
            var iterator = 0;
            filesArr.forEach(function (f, index) {
                if (!f.type.match('image.*')) return
            
                if (!multiple) singleUpload()
                else multipleUpload()

                function multipleUpload() {
                    if (imgArray.length > maxLength) {
                        $('.uploadWarn').html('*Upload limit max ' + (parseInt(maxLength) + 1) + ' items');
                        return false
                    } else {
                        $('.uploadWarn').html('')
                        var len = 0;
                        for (var i = 0; i < imgArray.length; i++) {
                            if (imgArray[i] !== undefined) {
                                len++;
                            }
                        }
                        if (len > maxLength) {
                            return false;
                        } else {
                            imgArray.push(f);

                            var reader = new FileReader();
                            reader.onload = function (e) {
                                var html = "<div class='uploadImgBox'><div style='background-image: url(" + e.target.result + ")' data-number='" + $(".-removeupic").length + "' data-file='" + f.name + "' class='uploadImgBg'><button aria-label='remove image' class='uploadImgClose -removeupic'></button></div></div>";
                                imgWrap.append(html);
                                iterator++;
                            }
                            reader.readAsDataURL(f);
                        }
                    }
                }

                function singleUpload() {
                    imgArray.push(f);

                    var reader = new FileReader();
                    reader.onload = function (e) {
                        var html = "<div class='uploadImgBox'><div style='background-image: url(" + e.target.result + ")' data-file='" + f.name + "' class='uploadImgBg'></div></div>";
                        imgWrap.html(html);
                    }
                    reader.readAsDataURL(f);
                }
            })
        })
    })
}

window.loadCustomSelect = (id) => {
    $('#' + id).each(function () {
        var $this = $(this),
            numberOfOptions = $(this).children('option').length,
            defaultSelected = $('#' + id).find(":selected").length

        $this.addClass('hidden');
        $this.wrap('<div class="select"></div>');
        $this.after('<div class="styledSelect"></div>')
        
        var $styledSelect = $this.next('div.styledSelect')
        if(defaultSelected > 0) {
            $styledSelect.text($('#' + id).find(":selected").text())
        } else {
            $styledSelect.text($this.children('option').eq(0).text())
        }
        
        var $list = $('<ul />', {
            'class': 'options hidden'
        }).insertAfter($styledSelect);

        for (var i = 0; i < numberOfOptions; i++) {
            $('<li />', {
                text: $this.children('option').eq(i).text(),
                rel: $this.children('option').eq(i).val()
            }).appendTo($list)
        }

        var $listItems = $list.children('li')
        $styledSelect.click(function (e) {
            e.stopPropagation();
            let option = $(this).next('ul.options')
            $('div.styledSelect.active').each(function () {
                $(this).removeClass('active')
            })
            $(this).toggleClass("active")
            option.toggleClass("hidden")
            if (option.hasClass('hidden')) {
                $(this).removeClass("open")
            } else {
                $(this).addClass("open")
            }
        });

        $listItems.click(function (e) {
            e.stopPropagation();
            $styledSelect.text($(this).text()).removeClass('active open')
            $this.val($(this).attr('rel'))
            $list.addClass('hidden')
            $this.trigger('change')
        });
        
        $(document).click(function () {
            $styledSelect.removeClass('active open')
            $list.addClass('hidden')
        })
    })
}

window.setShareLinks = () => {
    var pageUrl = encodeURIComponent(document.URL);
    var title = encodeURIComponent(document.title);

    $(".fbshare.shareButton").on("click", function() {
        url = "https://www.facebook.com/sharer.php?u=" + pageUrl;
        socialWindow(url);
    });

    $(".twshare.shareButton").on("click", function() {
        url = "https://twitter.com/intent/tweet?url=" + pageUrl + "&text=" + title;
        socialWindow(url);
    });

    $(".tgshare.shareButton").on("click", function() {
        url = "https://t.me/share/url?url=" + pageUrl + "&text=" + title;
        socialWindow(url, '_blank');
    });

    $(".lineshare.shareButton").on("click", function() {
        url = "https://social-plugins.line.me/lineit/share?url=" + pageUrl;
        socialWindow(url, '_blank');
    });

    $(".washare.shareButton").on("click", function() {
        url = "https://api.whatsapp.com/send?text=" + title + ' ' + pageUrl;
        socialWindow(url, '_blank');
    });

    $(".mailshare.shareButton").on("click", function() {
        url = "mailto:?Subject=" + title + "&amp;Body=" + pageUrl;
        socialWindow(url);
    });
}

window.socialWindow = (url, target = null) => {
    var left = (screen.width - 570) / 2;
    var top = (screen.height - 570) / 2;
    var params = "menubar=no,toolbar=no,status=no,width=570,height=570,top=" + top + ",left=" + left;
    if(target) {
        window.open(url, target);
    }

    window.open(url, "NewWindow", params);
}

window.copyLink = (id) => {
    let cTxt = document.getElementById(id);    
    cTxt.select();
    cTxt.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(cTxt.value);
}

window.showMore = (el, txt, txtrev, parentTg) => {
    if (!!parentTg) {
        let par = document.querySelector(parentTg),
            target = par.querySelector('.-jsShowTg');
        window.triggerTarget(el, txt, txtrev, target)
    } else {
        let target = el.parentNode.getElementsByClassName('-jsShowTg')[0];
        window.triggerTarget(el, txt, txtrev, target)
    }
}

window.triggerTarget = (elem, elemtxt, elemtxtrev, elemtarget) => {
    let elActive = elem.classList.contains('active');
    tgHeight = elemtarget.scrollHeight;

    elem.classList.toggle('active');
    elemtarget.style.maxHeight = elemtarget.style.maxHeight ? null : tgHeight + 'px';

    if (!!elemtxt) {
        if (elActive == false) {
            elem.innerHTML = elemtxt;
        } else {
            elem.innerHTML = elemtxtrev;
        }
    }
}

window.isNumber = (evt) => {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
    }
    return true;
}